export default __webpack_public_path__ + "static/media/LowBattery.8d687d1b.svg";